// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubMenu } from '../../../node_module_clones/react-contextmenu';
import { createSelector } from 'reselect';

// Utils
import { getIsDefaultBackground, getShowBoardGrid } from '../../canvas/background/boardBackgroundUtils';

// Selectors
import { getCurrentBoard } from '../../element/selectors/currentBoardSelector';
import { getCurrentUser } from '../../user/currentUserSelector';

// Actions
import {
    resetBoardBackgroundToDefault,
    updateCurrentBoardBackground,
} from '../../canvas/background/boardBackgroundActions';

// Components
import ContextMenuItem from './ContextMenuItem';
import ContextMenuDivider from './ContextMenuDivider';
import ContextMenuItemToggle from './ContextMenuItemToggle';
import CanvasColorContextMenuItem from './CanvasColorContextMenuItem';

const mapStateToProps = createSelector(getCurrentBoard, getCurrentUser, (currentBoard, currentUser) => {
    const isDefault = getIsDefaultBackground(currentBoard, currentUser);
    const showGrid = getShowBoardGrid(currentBoard, currentUser);

    return {
        isDefault,
        showGrid,
    };
});

const mapDispatchToProps = (dispatch) => ({
    dispatchToggleShowGrid: (enabled) => dispatch(updateCurrentBoardBackground({ showGrid: enabled })),
    dispatchResetToDefault: () => dispatch(resetBoardBackgroundToDefault()),
});

const BoardBackgroundContextMenuItems = (props) => {
    const {
        isDefault,
        showGrid,
        contextMenuHandlers,
        dispatchToggleShowGrid,
        dispatchResetToDefault,
        openBackgroundColorPicker,
    } = props;

    return (
        <SubMenu title="Change Board Background..." className="BoardBackgroundContextMenuItems">
            <CanvasColorContextMenuItem />
            <ContextMenuItem
                {...contextMenuHandlers}
                show
                onClick={openBackgroundColorPicker}
                title="Choose Custom Color..."
                id="chooseColor"
            />
            <ContextMenuDivider show />
            <ContextMenuItemToggle
                {...contextMenuHandlers}
                show
                active={showGrid}
                onClick={() => dispatchToggleShowGrid(!showGrid)}
                title="Show Dot Grid"
                id="showDotGrid"
            />
            <ContextMenuDivider show={!isDefault} />
            <ContextMenuItem
                {...contextMenuHandlers}
                show={!isDefault}
                onClick={dispatchResetToDefault}
                title="Revert to Default"
                id="revertToDefault"
            />
        </SubMenu>
    );
};

BoardBackgroundContextMenuItems.propTypes = {
    contextMenuHandlers: PropTypes.object,
    isDefault: PropTypes.bool,
    showGrid: PropTypes.bool,

    dispatchToggleShowGrid: PropTypes.func,
    dispatchResetToDefault: PropTypes.func,
    openBackgroundColorPicker: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardBackgroundContextMenuItems);
